import { render, staticRenderFns } from "./activityCenter.vue?vue&type=template&id=6425c310&scoped=true&"
import script from "./activityCenter.vue?vue&type=script&lang=ts&"
export * from "./activityCenter.vue?vue&type=script&lang=ts&"
import style0 from "./activityCenter.vue?vue&type=style&index=0&id=6425c310&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6425c310",
  null
  
)

export default component.exports